/**
 * Header Search Blur Effect
 * This script adds a blur effect to the entire page (including header) 
 * when the search is active, while keeping only the search input, results, and announcement bar clear
 */
(function() {
  // Wait for DOM to be fully loaded
  document.addEventListener('DOMContentLoaded', function() {
    // Create a blur overlay element
    const blurOverlay = document.createElement('div');
    blurOverlay.classList.add('search-blur-overlay');
    document.body.appendChild(blurOverlay);
    
    // Add the styles for the blur overlay
    const style = document.createElement('style');
    style.textContent = `
      .search-blur-overlay {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(0, 0, 0, 0.3);
        backdrop-filter: blur(1px);
        -webkit-backdrop-filter: blur(5px);
        z-index: 900;
        opacity: 0;
        visibility: hidden;
        transition: opacity 0.2s ease, visibility 0.2s ease;
        pointer-events: none;
      }
      
      .search-blur-overlay.active {
        opacity: 1;
        visibility: visible;
      }
      
      /* Only these specific search elements stay above blur with solid backgrounds */
      .header-inline-search {
        position: relative;
        z-index: 1000;
      }
      
      .header-search-container {
        position: relative;
        z-index: 1000;
        background: var(--color-background-header) !important; /* Solid background */
      }
      
      .header-search-results {
        position: absolute;
        z-index: 1000;
        background: var(--color-background-header) !important; /* Solid background */
        box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);
      }
      
      /* Keep the announcement bar above the blur */
      announcement-bar,
      .announcement-bar {
        position: relative;
        z-index: 1000;
        background: var(--color-background-header) !important; /* Solid background */
      }
    `;
    document.head.appendChild(style);
    
    // Listen for search activation events
    const searchInputs = document.querySelectorAll('.header-inline-search [data-js-search-input]');
    const searchResults = document.querySelectorAll('.header-search-results');
    
    // Check if search becomes active and show blur
    function checkSearchActive() {
      // If any search result is visible, activate blur
      const isSearchActive = Array.from(searchResults).some(el => {
        return el.classList.contains('visible') || 
               getComputedStyle(el).display !== 'none';
      });
      
      if (isSearchActive) {
        blurOverlay.classList.add('active');
      } else {
        blurOverlay.classList.remove('active');
      }
    }
    
    // Watch for focus on search inputs
    searchInputs.forEach(input => {
      input.addEventListener('focus', () => {
        // Only add blur if the input has a value
        if (input.value.trim().length > 0) {
          setTimeout(checkSearchActive, 100); // Short delay to let results show
        }
      });
      
      // Check when typing in search
      input.addEventListener('input', () => {
        if (input.value.trim().length > 0) {
          setTimeout(checkSearchActive, 300); // Delay to match search debounce
        } else {
          blurOverlay.classList.remove('active');
        }
      });
      
      // Handle escape key
      input.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') {
          blurOverlay.classList.remove('active');
        }
      });
    });
    
    // Remove blur when clicking outside search
    document.addEventListener('click', (e) => {
      if (!e.target.closest('.header-inline-search')) {
        blurOverlay.classList.remove('active');
      }
    });
    
    // Watch for changes in the DOM that might indicate search results appearing/disappearing
    const observer = new MutationObserver(checkSearchActive);
    searchResults.forEach(results => {
      observer.observe(results, { 
        attributes: true, 
        attributeFilter: ['class', 'style'],
        childList: true
      });
    });
  });
})();